import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectPodcastReadList } from '../features/podcastList/store/selectors';
import { updatePodcastReadList } from '../features/podcastList/store/slice';

export function useIsEpisodeRead(podcastId?: string, episodeId?: string): boolean {
  const readList = useAppSelector(selectPodcastReadList);
  return readList.some(([pId, eId]) => pId === podcastId && eId === episodeId);
}

export function useToggleEpisodeRead(podcastId: string, episodeId: string) {
  const readList = useAppSelector(selectPodcastReadList);
  const dispatch = useAppDispatch();
  return () => {
    const isRead = readList.some(([pId, eId]) => pId === podcastId && eId === episodeId);
    let newList;
    if (isRead) {
      // Si déjà lu, on le retire
      newList = readList.filter(
        ([pId, eId]) => !(pId === podcastId && eId === episodeId),
      );
    } else {
      // Sinon, on l'ajoute
      newList = [...readList, [podcastId, episodeId]];
    }
    dispatch(updatePodcastReadList(newList));
  };
}

export function useMarkEpisodeRead(podcastId: string, episodeId: string) {
  const readList = useAppSelector(selectPodcastReadList);
  const dispatch = useAppDispatch();
  return () => {
    const alreadyRead = readList.some(
      ([pId, eId]) => pId === podcastId && eId === episodeId,
    );
    if (alreadyRead) {
      return;
    }
    dispatch(updatePodcastReadList([...readList, [podcastId, episodeId]]));
  };
}
